import React, { useCallback, useMemo } from 'react';
import { Popover } from '@mantine/core';
import { copy } from '@shakkerai/util-copy';
import { useClickOutside } from '@mantine/hooks';
import { config } from '@shakkerai/config';
import { Button, Text, notifyError, notifySuccess, Textarea } from '@shakkerai/pro-components';
import { translate } from '@shakkerai/util-i18n';
import { Icon } from '@shakkerai/components';
import logo from './logo_normal.png';
// import { Tooltip } from '@mantine/core';
import { Tooltip } from 'antd';
import styles from './index.modules.scss';

// TODU
import { mc } from '@shakkerai/report';

const isOverseas = config.env === 'aws';

const buttonIcon = isOverseas ? (
  <Icon className="icon-shakker_logo mr-[4px]" fontSize={16} color="#00FFD1" />
) : (
  <img src={logo} className="h-[14px]" />
);

export const SharePopover = (props) => {
  const { children, imageId, url, opened, onClose, onMouseOver, onMouseLeave, imageInfo, onSendShakker } = props;

  const ref = useClickOutside(() => {
    onClose && onClose();
  });

  const onCopyLink = useCallback(() => {
    mc('tool.canvas.share', { image_id: imageId, from: 'copy_link' });

    copy(url).then(
      () => {
        notifySuccess(translate('copied'));
        onClose?.();
      },
      () => {
        notifyError(`Copy failed`);
      },
    );
    // eslint-disable-next-line
  }, [url]);

  const allText = useMemo(() => {
    return `${translate('share_image_content_prefix')} ${url}`;
  }, [url]);

  const onCopyAll = useCallback(() => {
    mc('tool.canvas.share', { image_id: imageId, from: 'copy_all' });

    copy(allText).then(
      () => {
        notifySuccess(translate('copied'));
        onClose?.();
      },
      () => {
        notifyError(`Copy failed`);
      },
    );
    // eslint-disable-next-line
  }, [allText]);

  const sendToShakker = useCallback(() => {
    if (!imageInfo.isNfsw) {
      onSendShakker?.();
    }
    onClose?.();
  }, [imageInfo, onClose, onSendShakker]);

  const btn = useMemo(() => {
    if (!imageInfo?.width) {
      return null;
    }
    if (imageInfo?.isNfsw) {
      return (
        <Tooltip
          withArrow
          zIndex={301}
          title="This image has been tagged as NFSW content, which is not allowed to share to Shakker"
        >
          <Button
            size="xs"
            className={`${styles.button} ${
              imageInfo?.isNfsw ? 'cursor-not-allowed' : ''
            } text-[14px] font-semibold ml-[24px]`}
            onClick={sendToShakker}
          >
            {buttonIcon}
            <span className="ml-1">{translate('image_publish_entry_btn')}</span>
          </Button>
        </Tooltip>
      );
    }
    return (
      <Button size="xs" className={`${styles.button}  text-[14px] font-semibold ml-[24px]`} onClick={sendToShakker}>
        {buttonIcon}
        <span className="ml-1">{translate('image_publish_entry_btn')}</span>
      </Button>
    );
  }, [imageInfo, sendToShakker]);

  if (!imageInfo) {
    return null;
  }

  return (
    <Popover
      width={540}
      opened={opened}
      position="bottom-end"
      radius={8}
      withArrow
      shadow="md"
      withinPortal={true}
      arrowOffset={40}
      className={styles.popover}
    >
      <Popover.Target>{children}</Popover.Target>
      <Popover.Dropdown onMouseOver={onMouseOver} onMouseLeave={onMouseLeave}>
        <div data-role="gen-history-trigger" ref={ref}>
          <Text>{translate('share_image_title')}</Text>
          <Textarea
            placeholder="Share target url."
            disabled={true}
            value={allText}
            className={`${styles.input} mt-[12px]`}
            onChange={() => {}}
          />
          <div
            className={`${styles.inputC} mt-[12px] w-full flex text-[14px] font-semibold text-[#2d2d2d] justify-end`}
          >
            <span onClick={onCopyLink} className="cursor-pointer">
              <Icon className="icon-a-0975-copylink mr-[4px]" fontSize={16} color="#2d2d2d" />
              {translate('share_image_link_title')}
            </span>
            <span className="ml-[24px] cursor-pointer" onClick={onCopyAll}>
              <Icon className="icon-a-0975-copyall mr-[4px]" fontSize={16} color="#2d2d2d" />
              {translate('share_image_all_title')}
            </span>
            {btn}
          </div>
        </div>
      </Popover.Dropdown>
    </Popover>
  );
};
